/* src/components/Solar/StateCounties.svelte generated by Svelte v3.48.0 */
import {
	SvelteComponent,
	add_render_callback,
	append_hydration,
	attr,
	check_outros,
	children,
	claim_element,
	claim_space,
	claim_text,
	create_bidirectional_transition,
	destroy_each,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert_hydration,
	listen,
	safe_not_equal,
	set_data,
	space,
	text,
	transition_in,
	transition_out
} from "svelte/internal";

import { onMount } from 'svelte';
import { slide } from 'svelte/transition';

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[9] = list[i];
	return child_ctx;
}

function get_each_context_1(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[9] = list[i];
	return child_ctx;
}

// (27:12) {#if getCountyInstallerCount(county.id) > 0}
function create_if_block_5(ctx) {
	let span;
	let t0_value = /*getCountyInstallerCount*/ ctx[3](/*county*/ ctx[9].id) + "";
	let t0;
	let t1;

	return {
		c() {
			span = element("span");
			t0 = text(t0_value);
			t1 = text(" Installers");
			this.h();
		},
		l(nodes) {
			span = claim_element(nodes, "SPAN", { class: true });
			var span_nodes = children(span);
			t0 = claim_text(span_nodes, t0_value);
			t1 = claim_text(span_nodes, " Installers");
			span_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(span, "class", "svelte-11mb1f0");
		},
		m(target, anchor) {
			insert_hydration(target, span, anchor);
			append_hydration(span, t0);
			append_hydration(span, t1);
		},
		p(ctx, dirty) {
			if (dirty & /*counties*/ 2 && t0_value !== (t0_value = /*getCountyInstallerCount*/ ctx[3](/*county*/ ctx[9].id) + "")) set_data(t0, t0_value);
		},
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

// (23:6) {#each counties.slice(0, 11) as county}
function create_each_block_1(ctx) {
	let li;
	let a;
	let t0_value = /*county*/ ctx[9].name + "";
	let t0;
	let t1;
	let show_if = /*getCountyInstallerCount*/ ctx[3](/*county*/ ctx[9].id) > 0;
	let a_href_value;
	let if_block = show_if && create_if_block_5(ctx);

	return {
		c() {
			li = element("li");
			a = element("a");
			t0 = text(t0_value);
			t1 = space();
			if (if_block) if_block.c();
			this.h();
		},
		l(nodes) {
			li = claim_element(nodes, "LI", { class: true });
			var li_nodes = children(li);
			a = claim_element(li_nodes, "A", { href: true, class: true });
			var a_nodes = children(a);
			t0 = claim_text(a_nodes, t0_value);
			t1 = claim_space(a_nodes);
			if (if_block) if_block.l(a_nodes);
			a_nodes.forEach(detach);
			li_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(a, "href", a_href_value = /*county*/ ctx[9].permalink);
			attr(a, "class", "svelte-11mb1f0");
			attr(li, "class", "svelte-11mb1f0");
		},
		m(target, anchor) {
			insert_hydration(target, li, anchor);
			append_hydration(li, a);
			append_hydration(a, t0);
			append_hydration(a, t1);
			if (if_block) if_block.m(a, null);
		},
		p(ctx, dirty) {
			if (dirty & /*counties*/ 2 && t0_value !== (t0_value = /*county*/ ctx[9].name + "")) set_data(t0, t0_value);
			if (dirty & /*counties*/ 2) show_if = /*getCountyInstallerCount*/ ctx[3](/*county*/ ctx[9].id) > 0;

			if (show_if) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_5(ctx);
					if_block.c();
					if_block.m(a, null);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			if (dirty & /*counties*/ 2 && a_href_value !== (a_href_value = /*county*/ ctx[9].permalink)) {
				attr(a, "href", a_href_value);
			}
		},
		d(detaching) {
			if (detaching) detach(li);
			if (if_block) if_block.d();
		}
	};
}

// (42:58) 
function create_if_block_4(ctx) {
	let li;
	let button;
	let t0;
	let t1_value = /*counties*/ ctx[1].length + "";
	let t1;
	let t2;
	let mounted;
	let dispose;

	return {
		c() {
			li = element("li");
			button = element("button");
			t0 = text("Show ");
			t1 = text(t1_value);
			t2 = text(" Counties");
			this.h();
		},
		l(nodes) {
			li = claim_element(nodes, "LI", { class: true });
			var li_nodes = children(li);
			button = claim_element(li_nodes, "BUTTON", { class: true });
			var button_nodes = children(button);
			t0 = claim_text(button_nodes, "Show ");
			t1 = claim_text(button_nodes, t1_value);
			t2 = claim_text(button_nodes, " Counties");
			button_nodes.forEach(detach);
			li_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(button, "class", "svelte-11mb1f0");
			attr(li, "class", "svelte-11mb1f0");
		},
		m(target, anchor) {
			insert_hydration(target, li, anchor);
			append_hydration(li, button);
			append_hydration(button, t0);
			append_hydration(button, t1);
			append_hydration(button, t2);

			if (!mounted) {
				dispose = listen(button, "click", /*click_handler*/ ctx[8]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty & /*counties*/ 2 && t1_value !== (t1_value = /*counties*/ ctx[1].length + "")) set_data(t1, t1_value);
		},
		d(detaching) {
			if (detaching) detach(li);
			mounted = false;
			dispose();
		}
	};
}

// (33:6) {#if counties.length === 12}
function create_if_block_2(ctx) {
	let li;
	let a;
	let t0_value = /*counties*/ ctx[1][11].name + "";
	let t0;
	let t1;
	let show_if = /*getCountyInstallerCount*/ ctx[3](/*counties*/ ctx[1][11].id) > 0;
	let a_href_value;
	let if_block = show_if && create_if_block_3(ctx);

	return {
		c() {
			li = element("li");
			a = element("a");
			t0 = text(t0_value);
			t1 = space();
			if (if_block) if_block.c();
			this.h();
		},
		l(nodes) {
			li = claim_element(nodes, "LI", { class: true });
			var li_nodes = children(li);
			a = claim_element(li_nodes, "A", { href: true, class: true });
			var a_nodes = children(a);
			t0 = claim_text(a_nodes, t0_value);
			t1 = claim_space(a_nodes);
			if (if_block) if_block.l(a_nodes);
			a_nodes.forEach(detach);
			li_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(a, "href", a_href_value = /*counties*/ ctx[1][11].permalink);
			attr(a, "class", "svelte-11mb1f0");
			attr(li, "class", "svelte-11mb1f0");
		},
		m(target, anchor) {
			insert_hydration(target, li, anchor);
			append_hydration(li, a);
			append_hydration(a, t0);
			append_hydration(a, t1);
			if (if_block) if_block.m(a, null);
		},
		p(ctx, dirty) {
			if (dirty & /*counties*/ 2 && t0_value !== (t0_value = /*counties*/ ctx[1][11].name + "")) set_data(t0, t0_value);
			if (dirty & /*counties*/ 2) show_if = /*getCountyInstallerCount*/ ctx[3](/*counties*/ ctx[1][11].id) > 0;

			if (show_if) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_3(ctx);
					if_block.c();
					if_block.m(a, null);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			if (dirty & /*counties*/ 2 && a_href_value !== (a_href_value = /*counties*/ ctx[1][11].permalink)) {
				attr(a, "href", a_href_value);
			}
		},
		d(detaching) {
			if (detaching) detach(li);
			if (if_block) if_block.d();
		}
	};
}

// (37:12) {#if getCountyInstallerCount(counties[11].id) > 0}
function create_if_block_3(ctx) {
	let span;
	let t0_value = /*getCountyInstallerCount*/ ctx[3](/*counties*/ ctx[1][11].id) + "";
	let t0;
	let t1;

	return {
		c() {
			span = element("span");
			t0 = text(t0_value);
			t1 = text(" Installers");
			this.h();
		},
		l(nodes) {
			span = claim_element(nodes, "SPAN", { class: true });
			var span_nodes = children(span);
			t0 = claim_text(span_nodes, t0_value);
			t1 = claim_text(span_nodes, " Installers");
			span_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(span, "class", "svelte-11mb1f0");
		},
		m(target, anchor) {
			insert_hydration(target, span, anchor);
			append_hydration(span, t0);
			append_hydration(span, t1);
		},
		p(ctx, dirty) {
			if (dirty & /*counties*/ 2 && t0_value !== (t0_value = /*getCountyInstallerCount*/ ctx[3](/*counties*/ ctx[1][11].id) + "")) set_data(t0, t0_value);
		},
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

// (49:6) {#if showMoreCounties}
function create_if_block(ctx) {
	let each_1_anchor;
	let current;
	let each_value = /*counties*/ ctx[1].slice(11, /*counties*/ ctx[1].length);
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	return {
		c() {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			each_1_anchor = empty();
		},
		l(nodes) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(nodes);
			}

			each_1_anchor = empty();
		},
		m(target, anchor) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(target, anchor);
			}

			insert_hydration(target, each_1_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (dirty & /*counties, getCountyInstallerCount*/ 10) {
				each_value = /*counties*/ ctx[1].slice(11, /*counties*/ ctx[1].length);
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
					}
				}

				group_outros();

				for (i = each_value.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			destroy_each(each_blocks, detaching);
			if (detaching) detach(each_1_anchor);
		}
	};
}

// (54:14) {#if getCountyInstallerCount(county.id) > 0}
function create_if_block_1(ctx) {
	let span;
	let t0_value = /*getCountyInstallerCount*/ ctx[3](/*county*/ ctx[9].id) + "";
	let t0;
	let t1;

	return {
		c() {
			span = element("span");
			t0 = text(t0_value);
			t1 = text(" Installers");
			this.h();
		},
		l(nodes) {
			span = claim_element(nodes, "SPAN", { class: true });
			var span_nodes = children(span);
			t0 = claim_text(span_nodes, t0_value);
			t1 = claim_text(span_nodes, " Installers");
			span_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(span, "class", "svelte-11mb1f0");
		},
		m(target, anchor) {
			insert_hydration(target, span, anchor);
			append_hydration(span, t0);
			append_hydration(span, t1);
		},
		p(ctx, dirty) {
			if (dirty & /*counties*/ 2 && t0_value !== (t0_value = /*getCountyInstallerCount*/ ctx[3](/*county*/ ctx[9].id) + "")) set_data(t0, t0_value);
		},
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

// (50:8) {#each counties.slice(11, counties.length) as county}
function create_each_block(ctx) {
	let li;
	let a;
	let t0_value = /*county*/ ctx[9].name + "";
	let t0;
	let t1;
	let show_if = /*getCountyInstallerCount*/ ctx[3](/*county*/ ctx[9].id) > 0;
	let a_href_value;
	let t2;
	let li_transition;
	let current;
	let if_block = show_if && create_if_block_1(ctx);

	return {
		c() {
			li = element("li");
			a = element("a");
			t0 = text(t0_value);
			t1 = space();
			if (if_block) if_block.c();
			t2 = space();
			this.h();
		},
		l(nodes) {
			li = claim_element(nodes, "LI", { class: true });
			var li_nodes = children(li);
			a = claim_element(li_nodes, "A", { href: true, class: true });
			var a_nodes = children(a);
			t0 = claim_text(a_nodes, t0_value);
			t1 = claim_space(a_nodes);
			if (if_block) if_block.l(a_nodes);
			a_nodes.forEach(detach);
			t2 = claim_space(li_nodes);
			li_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(a, "href", a_href_value = /*county*/ ctx[9].permalink);
			attr(a, "class", "svelte-11mb1f0");
			attr(li, "class", "svelte-11mb1f0");
		},
		m(target, anchor) {
			insert_hydration(target, li, anchor);
			append_hydration(li, a);
			append_hydration(a, t0);
			append_hydration(a, t1);
			if (if_block) if_block.m(a, null);
			append_hydration(li, t2);
			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty & /*counties*/ 2) && t0_value !== (t0_value = /*county*/ ctx[9].name + "")) set_data(t0, t0_value);
			if (dirty & /*counties*/ 2) show_if = /*getCountyInstallerCount*/ ctx[3](/*county*/ ctx[9].id) > 0;

			if (show_if) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_1(ctx);
					if_block.c();
					if_block.m(a, null);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			if (!current || dirty & /*counties*/ 2 && a_href_value !== (a_href_value = /*county*/ ctx[9].permalink)) {
				attr(a, "href", a_href_value);
			}
		},
		i(local) {
			if (current) return;

			add_render_callback(() => {
				if (!li_transition) li_transition = create_bidirectional_transition(li, slide, {}, true);
				li_transition.run(1);
			});

			current = true;
		},
		o(local) {
			if (!li_transition) li_transition = create_bidirectional_transition(li, slide, {}, false);
			li_transition.run(0);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(li);
			if (if_block) if_block.d();
			if (detaching && li_transition) li_transition.end();
		}
	};
}

function create_fragment(ctx) {
	let section;
	let div;
	let h2;
	let t0;
	let t1;
	let ul;
	let t2;
	let t3;
	let current;
	let each_value_1 = /*counties*/ ctx[1].slice(0, 11);
	let each_blocks = [];

	for (let i = 0; i < each_value_1.length; i += 1) {
		each_blocks[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
	}

	function select_block_type(ctx, dirty) {
		if (/*counties*/ ctx[1].length === 12) return create_if_block_2;
		if (/*counties*/ ctx[1].length > 11 && !/*showMoreCounties*/ ctx[2]) return create_if_block_4;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block0 = current_block_type && current_block_type(ctx);
	let if_block1 = /*showMoreCounties*/ ctx[2] && create_if_block(ctx);

	return {
		c() {
			section = element("section");
			div = element("div");
			h2 = element("h2");
			t0 = text(/*headline*/ ctx[0]);
			t1 = space();
			ul = element("ul");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t2 = space();
			if (if_block0) if_block0.c();
			t3 = space();
			if (if_block1) if_block1.c();
			this.h();
		},
		l(nodes) {
			section = claim_element(nodes, "SECTION", { id: true, class: true });
			var section_nodes = children(section);
			div = claim_element(section_nodes, "DIV", { class: true });
			var div_nodes = children(div);
			h2 = claim_element(div_nodes, "H2", { class: true });
			var h2_nodes = children(h2);
			t0 = claim_text(h2_nodes, /*headline*/ ctx[0]);
			h2_nodes.forEach(detach);
			t1 = claim_space(div_nodes);
			ul = claim_element(div_nodes, "UL", { class: true });
			var ul_nodes = children(ul);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(ul_nodes);
			}

			t2 = claim_space(ul_nodes);
			if (if_block0) if_block0.l(ul_nodes);
			t3 = claim_space(ul_nodes);
			if (if_block1) if_block1.l(ul_nodes);
			ul_nodes.forEach(detach);
			div_nodes.forEach(detach);
			section_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(h2, "class", "state-counties__headline svelte-11mb1f0");
			attr(ul, "class", "state-counties__list svelte-11mb1f0");
			attr(div, "class", "state-counties__wrapper container svelte-11mb1f0");
			attr(section, "id", "solar-counties");
			attr(section, "class", "state-counties svelte-11mb1f0");
		},
		m(target, anchor) {
			insert_hydration(target, section, anchor);
			append_hydration(section, div);
			append_hydration(div, h2);
			append_hydration(h2, t0);
			append_hydration(div, t1);
			append_hydration(div, ul);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(ul, null);
			}

			append_hydration(ul, t2);
			if (if_block0) if_block0.m(ul, null);
			append_hydration(ul, t3);
			if (if_block1) if_block1.m(ul, null);
			current = true;
		},
		p(ctx, [dirty]) {
			if (!current || dirty & /*headline*/ 1) set_data(t0, /*headline*/ ctx[0]);

			if (dirty & /*counties, getCountyInstallerCount*/ 10) {
				each_value_1 = /*counties*/ ctx[1].slice(0, 11);
				let i;

				for (i = 0; i < each_value_1.length; i += 1) {
					const child_ctx = get_each_context_1(ctx, each_value_1, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block_1(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(ul, t2);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value_1.length;
			}

			if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block0) {
				if_block0.p(ctx, dirty);
			} else {
				if (if_block0) if_block0.d(1);
				if_block0 = current_block_type && current_block_type(ctx);

				if (if_block0) {
					if_block0.c();
					if_block0.m(ul, t3);
				}
			}

			if (/*showMoreCounties*/ ctx[2]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty & /*showMoreCounties*/ 4) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(ul, null);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block1);
			current = true;
		},
		o(local) {
			transition_out(if_block1);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(section);
			destroy_each(each_blocks, detaching);

			if (if_block0) {
				if_block0.d();
			}

			if (if_block1) if_block1.d();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { headline, name, stateSlug, state, counties, installersPerCounty } = $$props;
	let showMoreCounties = true;

	const getCountyInstallerCount = id => {
		return Number(installersPerCounty.find(c => c.id === id)?.installers);
	};

	onMount(() => {
		$$invalidate(2, showMoreCounties = false);
	});

	const click_handler = () => $$invalidate(2, showMoreCounties = true);

	$$self.$$set = $$props => {
		if ('headline' in $$props) $$invalidate(0, headline = $$props.headline);
		if ('name' in $$props) $$invalidate(4, name = $$props.name);
		if ('stateSlug' in $$props) $$invalidate(5, stateSlug = $$props.stateSlug);
		if ('state' in $$props) $$invalidate(6, state = $$props.state);
		if ('counties' in $$props) $$invalidate(1, counties = $$props.counties);
		if ('installersPerCounty' in $$props) $$invalidate(7, installersPerCounty = $$props.installersPerCounty);
	};

	return [
		headline,
		counties,
		showMoreCounties,
		getCountyInstallerCount,
		name,
		stateSlug,
		state,
		installersPerCounty,
		click_handler
	];
}

class StateCounties extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			headline: 0,
			name: 4,
			stateSlug: 5,
			state: 6,
			counties: 1,
			installersPerCounty: 7
		});
	}
}

export default StateCounties;